// @ts-nocheck
/* Starter Sync - modules\mobius\src\Overlay\helpers\ariaAppHider.ts */

import { canUseDOM } from "exenv";
import warning from "tiny-warning";

let globalElement: HTMLElement | null = null;
let globalSelector: string | null = null;

export function assertNodeList(nodeList: { length: number }, selector: string) {
    if (!nodeList || !nodeList.length) {
        throw new Error(`mobius: No elements were found for selector ${selector}.`);
    }
}

function resolveElement() {
    if (globalElement || !globalSelector || !canUseDOM) {
        return globalElement;
    }

    globalElement = document.querySelector<HTMLElement>(globalSelector);
    return globalElement;
}

/** Starter Custom Code - @deprecated setElement is no longer used for accessibility purpose */
export function setElement(element: string) {
    globalSelector = element;
    globalElement = null;
    return resolveElement();
}

/** Starter Custom Code - @deprecated validateElement is no longer used for accessibility purpose */
export function validateElement(appElement: HTMLElement) {
    if (!appElement && !resolveElement()) {
        warning(
            false,
            [
                `mobius: Overlay app element was not found${globalSelector ? ` for selector ${globalSelector}` : ""}.`,
                "Please use `Overlay.setAppElement(el)` or set `appElement={el}`.",
                "This is needed so screen readers don't see main content",
                "when modal is opened.",
            ].join(" "),
        );

        return false;
    }

    return true;
}

/** Starter Custom Code - setAttribute aria-hidden is no longer used for accessibility purpose */
export function hide(appElement: HTMLElement) {
    // Starter Removed - setAttribute aria-hidden
    // Starter Removed - validateElement
    document.querySelector("body")?.setAttribute("style", "overflow: hidden;");
}

export function show(appElement: HTMLElement) {
    // Starter Removed - removeAttribute aria-hidden
    // Starter Removed - validateElement
    document.querySelector("body")?.removeAttribute("style");
}
